module.exports = "/_next/static/images/469d34288fdac1a9619eb0e04a9d4787-open-graph-experiment-large.jpg";